module.exports = __webpack_public_path__ + "img/TrailerThumbnail.a946108a.png";